import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'medApp_currentUser';

const getStoredSession = () => {
  const session = localStorage.getItem(STORAGE_KEY);
  return session ? JSON.parse(session) : null;
};

const saveSession = (session) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

const clearSession = () => {
  localStorage.removeItem(STORAGE_KEY);
};

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const session = getStoredSession();
    if (session?.user) {
      setCurrentUser(session.user);
    }
    setLoading(false);
  }, []);

  const login = (authData) => {
  // Attach permissions to user object
  const userWithPermissions = {
    ...authData.user,
    permissions: authData.permissions || [],
  };

  // Prepare session to store in localStorage
  const session = {
    user: userWithPermissions,
    access_token: authData.access_token,
    token_type: authData.token_type,
  };

  // Save session in localStorage
  saveSession(session);

  // Update currentUser state with permissions included
  setCurrentUser(userWithPermissions);
};


  const logout = () => {
    clearSession();
    setCurrentUser(null);
    
  };

  const value = {
    currentUser,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
